import React, { Component } from 'react';

import { Link } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import axios from 'axios';
import opening from './img/opening.png';
import longheaderblue from './img/longheaderblue.png';
import newheader from './img/newheader1000.png';

const API_PATH = '../form.php';




class AboutUs extends Component {







render() {
		return (

	<div className="container-fluid appdesc">
	<div className="row padrow">
		<div className="col-md-12 col-lg-12">
					<h2>About Us</h2>
		</div>
		</div>

<div className="row padrow">
<div className="col-md-12 main corners">
<div className="plaintext">

<p>Helen's Software Company is a small, independent application development company focused on applications to make life easier.  We have a small staff headquartered in Plano, TX.</p>

<h2>Important Things to Know</h2>

<ul>
<li> None of our apps have in-app purchases, other than a potential one-time ability to update from free to paid versions.</li>
<li> We ourselves do not track anything about you as a company, other than information on the use of our app as collected through the Google play store.   Our free apps use AdMob advertising from Google, which may track certain information.  See our privacy policy <Link to="/privacy" >
here
</Link>.</li>
			 </ul>




		</div>

</div>
</div>
<div className="row padrow">
<div className="col-md-12 main corners">
<div className="plaintext">
	Check out our <a href="https://www.youtube.com/channel/UC4eN-brmGnxMLAYw3N5tA_g">YouTube channel!</a>
</div>
</div>
</div>

	</div>


		)
}

}
export default AboutUs;
